import { ATTR_NAMES } from './attrNames';

/**
 * The reader's own details (CMS-1905). Both are optional: the group renders
 * only the controls the market's product data supports, and income is empty
 * until the reader types one.
 */
export type EligibilityDetails = {
  /** One of the values the page's products carry, matched exactly (AC 2d). */
  citizenship?: string;
  /** What the reader earns per month, in the market's own currency. */
  monthlyIncome?: number;
};

/**
 * What one loan shows. `NONE` is the resting state and covers two different
 * situations the reader cannot tell apart and does not need to: no income
 * entered yet, and a lender that publishes no criteria we can check (AC 3e).
 */
export type EligibilityOutcome =
  | 'MEETS'
  | 'SHORT_INCOME'
  | 'SHORT_CITIZENSHIP'
  | 'NONE';

export type EligibilityVerdict = {
  outcome: EligibilityOutcome;
  /**
   * The lender's published minimum, for the income message. Set only on
   * `SHORT_INCOME`, since that is the only message that names a figure.
   */
  requiredAnnualIncome?: number;
};

/** Nothing entered and nothing to say — a stable identity, so memoising works. */
export const NO_VERDICT: EligibilityVerdict = { outcome: 'NONE' };

export const MINIMUM_ANNUAL_INCOME = ATTR_NAMES.MINIMUM_ANNUAL_INCOME;
export const CITIZENSHIP_TYPE = ATTR_NAMES.CITIZENSHIP_TYPE;

/** Lenders publish a year's income; the reader enters a month's (UC 3). */
export const MONTHS_PER_YEAR = 12;
